<template>
  <component v-if="text" :is="tag" class="caption" v-html="text"></component>
</template>

<script>
export default {
  name: 'BaseCaption',
  props: {
    text: {
      required: true,
      type: [String, Number]
    },
    tag: {
      type: String,
      default: 'h2'
    }
  }
}
</script>

<style lang="scss">
.caption {
  font-family: $ToyotaBook;
  font-size: 13px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #282830;
}

h6.caption{
  font-family: $ToyotaBook;
  font-size: 11px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #282830;
  margin: 0;
}
@include media-min($tablet-width) {
  .caption {
    font-size: 15px;
    line-height: 18px;
  }
  h6.caption {
    font-size: 12px;
    line-height: 16px;
  }
}

@include media-min($desktop-width) {
  .caption {
    font-size: 17px;
    line-height: 1.35;
  }
  h6.caption {
    font-size: 14px;
    line-height: 1.35;
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseCaption.vue